// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wvNEf","colBig":"styles_colBig__QqcCc","colSmall":"styles_colSmall__MJ7j9","shopifyNameWrapper":"styles_shopifyNameWrapper__2Pv-K"};